export const CayusWave = ({ animated = false, className = "", opacity = 1 }) => (
  <svg
    viewBox="0 0 1200 120"
    fill="none"
    preserveAspectRatio="none"
    className={`${animated ? "wave-draw" : ""} ${className}`}
    style={{ opacity }}
    aria-hidden="true"
  >
    <path
      d="M0 62 C 90 62, 130 24, 210 34 S 360 98, 460 72 S 620 14, 740 42 S 930 92, 1040 60 S 1150 44, 1200 56"
      stroke="#0047AB"
      strokeWidth="1.5"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export default CayusWave;
